import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

let paths = [
  {
    path: "/",
    redirect: "dashboard",
    component: () => import("@/views/Layout.vue"),
    children: [
      {
        name: "dashboard",
        path: "dashboard",
        meta: {},
        component: () => import("@/views/Home.vue")
      },
      {
        name: "contacts",
        path: "contacts",
        meta: {},
        component: () => import("@/views/Contacts.vue")
      },
      {
        name: "contact",
        path: "contact/:id",
        props: true,
        component: () => import("@/views/Contact.vue")
      },
      {
        name: "track",
        path: "/track",
        meta: {},
        component: () => import("@/views/Track.vue")
      },
      {
        name: "track_id",
        path: "/track/:id",
        props: true,
        component: () => import("@/views/Track.vue")
      },
      {
        name: "request",
        path: "/request/:id",
        props: true,
        meta: {},
        component: () => import("@/views/Request.vue")
      },
      {
        path: "/shipments",
        name: "shipments",
        meta: {},
        component: () => import("@/views/Shipments.vue")
      },
      {
        path: "/cod",
        name: "cod",
        meta: {
          rule: "/report/cash-on-delivery"
        },
        component: () => import("@/views/Cod.vue")
      },
      {
        path: "/invoices",
        name: "invoices",
        meta: {
          rule: "/invoice"
        },
        component: () => import("./views/Invoice.vue")
      },
      {
        path: "/invoices/:id",
        name: "invoice",
        props: true,
        component: () => import("./views/InvoiceDetails.vue")
      },
      {
        path: "/wms",
        name: "wms",
        component: () => import("@/views/Wms.vue"),
        redirect: "/wms/products/store",
        children: [
          {
            path: "/wms/products/:mode",
            name: "wmsProducts",
            props: true,
            component: () => import("@/views/WmsProducts.vue")
          },
          {
            path: "/wms/orders",
            name: "wmsOrders",
            component: () => import("@/views/WmsOrders.vue")
          }
        ]
      },
      {
        path: "/consumables",
        name: "consumables",
        component: () => import("@/views/Consumables.vue"),
        redirect: "/consumables/products",
        children: [
          {
            path: "/consumables/products",
            name: "consumablesProducts",
            component: () => import("@/views/ConsumablesProducts.vue")
          },
          {
            path: "/consumables/orders",
            name: "consumablesOrders",
            component: () => import("@/views/ConsumablesOrders.vue")
          }
        ]
      },
      {
        path: "/contact-us",
        name: "contact-us",
        meta: {},
        component: () => import("./views/ContactUs.vue")
      },
      {
        path: "/imports",
        name: "imports",
        meta: {
          index: 30,
          icon: "import_export",
          title: "imports screen"
        },
        redirect: "/imports/import",
        component: () => import("./views/Imports.vue"),
        children: [
          {
            path: "/imports/import",
            name: "importTmpl",
            component: () => import("./views/TmplImport.vue")
          },
          {
            path: "/imports/export",
            name: "exportTmpl",
            component: () => import("./views/TmplExport.vue")
          }
        ]
      },
      {
        path: "/cases",
        name: "cases",
        meta: {},
        component: () => import("./views/Cases.vue")
      },
    ]
  },
  {
    path: "/signin",
    name: "signin",
    component: () => import("@/views/login/MaterialSignin.vue")
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/login/Register.vue")
  },
  {
    path: "/register/:id/:token",
    name: "verify",
    props: true,
    component: () => import("@/views/login/Register.vue")
  }
];

export default new Router({
  routes: paths
});
